import { Table, Dropdown } from "antd";
import { CopyOutlined, EditOutlined, DeleteOutlined, MoreOutlined } from '@ant-design/icons';
import './JobAdList.css'
import moment from 'moment';
import iconRename from '../../icons/icon-rename.svg';


function JobAdList({ dataSource, actionsHandler, clickCardHandler, showMenu }) {

    const items = [
        {
            key: 'rename',
            icon: <img src={iconRename} alt="rename" className="jobadcard-rename-icon" />,
            label: 'Rename',
        },
        {
            key: 'duplicate',
            icon: <CopyOutlined />,
            label: 'Duplicate',
        }
        ,
        {
            key: 'edit',
            icon: <EditOutlined />,
            label: 'Edit',
        },
        {
            key: 'delete',
            icon: <DeleteOutlined />,
            label: 'Delete',
        }
    ];

    const onClickDropdown = (e) => {
        e.stopPropagation();
    }

    const menuClicked = (event, id) => {
        event.domEvent.stopPropagation();
        actionsHandler({
            action: event.key,
            id
        });
    };

    return (
        <div className='jobad-list-container' >

            <Table
                dataSource={dataSource}
                rowKey="id"
                pagination={false}
                sticky={{ offsetHeader: 0, }}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: (event) => { clickCardHandler(record.id) }, // click row
                    };
                }}
                columns={[
                    {
                        title: 'Title',
                        dataIndex: 'title',
                        key: 'title',
                        className: 'jobad-list-title',
                    },
                    {
                        title: 'SPC',
                        dataIndex: 'options',
                        key: 'spc',
                        render: (value, record) => (
                            value.spc || 'Undefined'
                        )
                    },
                    {
                        title: 'Last modified',
                        dataIndex: 'modificationDate',
                        key: 'date',
                        render: (value, record) => (
                            moment(value).format('LLL')
                        )
                    },
                    {
                        title: '',
                        dataIndex: '',
                        key: 'x',
                        width: 50,
                        fixed: 'right',
                        className: 'jobad-list-action',
                        render: (text, record) => (
                            showMenu && <Dropdown onClick={onClickDropdown}
                                menu={{ items, onClick: (event) => { menuClicked(event, record.id) } }}
                                overlayClassName='jobadcard-dropdown-overlay'
                            >
                                <MoreOutlined />
                            </Dropdown>
                        )
                    }
                ]}
            />

        </div>
    )

}

export default JobAdList;
